// Program prices shown on the site. The amount actually charged (and the
// coupon codes) live on the server in server/config/programs.js, so change
// both together.
export const SKILL_DEVELOPMENT = {
  slug: 'skill-development',
  name: 'Skill Development Program',
  listPriceInr: 75000,
  priceInr: 50000
};
